/* RenameFolderAction.js */

"use strict";
const _ = require("lodash");
const RenameFolderComponent = require("./RenameFolderComponent");

class RenameFolderAction {
    constructor(logger, gameEditor, modalUserFeedback, OsImagePaths, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._osImagePathsEntity = OsImagePaths;
        this._activeOrgId = userSession.activeOrganization.id;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this.run = this.run.bind(this);

        const pathIdToRename = _.get(this._activeView.explorerState, "selectedPathId");
        const treeNodes = this._activeView.renderer._treeComponent.getTreeNodes();
        const node = treeNodes.find((node) => node.id === pathIdToRename);
        this.run = this.run.bind(this, node);
    }
    run(node) {
        if (!node || !this._activeView.canEditFolders()) {
            return Promise.resolve();
        }
        const {id: nodeId, name: nodeName} = node;
        return this._modalUserFeedback
            .displayCustom(new RenameFolderComponent(this._logger, {name: nodeName}), {
                dontHide: true,
            })
            .then((newName) => this._renameFolder(nodeId, newName))
            .catch((error) => {
                if (error && !error.userRejected) {
                    this._logger.warn({error}, "RenameFolderAction.run()");
                    return this._modalUserFeedback.displayError(error);
                }
            })
            .then(() => this._modalUserFeedback.hideDisplayed());
    }
    /* jshint ignore:start */
    async _renameFolder(pathId, name) {
        name = name && name.trim();
        let osip = await this._osImagePathsEntity.loadPaths(this._activeOrgId);
        osip.renamePath(pathId === "" ? null : pathId, name);
        return await osip.update();
    }
    /* jshint ignore:end */
}
module.exports = RenameFolderAction;

RenameFolderAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OsImagePaths",
    "$teve.userSession",
    "gameEditor.activeView",
];

RenameFolderAction.$displayDetails = {
    type: "Action",
    name: "RenameFolderAction",
    icon: "fileserver.rename_folder",
    shown: true,
    title: "Rename Folder",
    order: 2,
};
